;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('selectionSidebar', selectionSidebarDirective)

  SelectionSidebarController.$inject = [
    // Angular
    '$rootScope', '$state', '$http', 'urls', '$window', '$uibModal',

    // Services
    'SnackService', 'DisplayService', 'PreferencesService', 'TemplateService', 'AppAccessService', 'ChorusService', 'PennylaneService',

    // Managers
    'ProductManager', 'CreditNoteManager', 'InvoiceManager', 'QuoteManager'

  ]

  function SelectionSidebarController (
    // Angular
    $rootScope, $state, $http, urls, $window, $uibModal,

    // Services
    SnackService, DisplayService, PreferencesService, TemplateService, AppAccessService, ChorusService, PennylaneService,

    // Managers
    ProductManager, CreditNoteManager, InvoiceManager, QuoteManager

  ) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        haveChorusAccess: false,
        pennylaneConnected: false,
        // Methods
        init: init,
        newTab: newTab,
        asCsv: asCsv,
        asSpreadsheet: asSpreadsheet,
        displayDeleteOrModification: displayDeleteOrModification,
        displayArchive: displayArchive,
        displayRestore: displayRestore,
        displayBulkValidate: displayBulkValidate,
        deleteSelection: deleteSelection,
        modifySelection: modifySelection,
        updatePrices: updatePrices,
        archiveSelection: archiveSelection,
        restoreSelection: restoreSelection,
        displayPdf: displayPdf,
        displayBulkSent: displayBulkSent,
        displayBulkDunning: displayBulkDunning,
        displayBulkLitigation: displayBulkLitigation,
        displayBulkPaid: displayBulkPaid,
        displayChorus,
        isChorusSelection,
        bulkValidate: bulkValidate,
        bulkStatus: bulkStatus,
        bulkPayment: bulkPayment,
        bulkSynchroToChorus,
        displayPennylaneEmit,
        bulkEmitToPennylane,
        asPdf: asPdf,
        displayDelete: displayDelete,
        deleteQuoteInvoiceCreditNote: deleteQuoteInvoiceCreditNote
      })

      init()
    }

    function init () {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
      })
      AppAccessService.getCompanyRights().then((rights) => {
        rights.forEach((right) => {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true
        })
      })
      // Pennylane : uniquement pour la liste des factures (pas d'appel pour les
      // autres types). getConnectedCompany est mémoïsée et ne rejette jamais.
      if (self.type === 'invoice') {
        PennylaneService.getConnectedCompany().then((company) => {
          self.pennylaneConnected = !!company
        })
      }
    }

    function displayDelete () {
      const selected = _.get(self, 'selection.selectedData', [])
      const availableElements = ['quote', 'creditnote', 'invoice']
      return selected.filter((el) => el.status === 'draft').length === selected.length && availableElements.includes(self.type)
    }

    function deleteQuoteInvoiceCreditNote () {
      DisplayService.confirmDeletion().then(function () {
        let manager
        let typeTranslate
        switch (self.type) {
          case 'quote':
            manager = QuoteManager
            typeTranslate = 'Devis'
            break
          case 'invoice':
            manager = InvoiceManager
            typeTranslate = 'Facture(s)'
            break
          case 'creditnote':
            manager = CreditNoteManager
            typeTranslate = 'Avoir(s)'
            break
        }
        manager.delete(_.get(self, 'selection.selectedData', [])).then(() => {
          SnackService.snack({
            text: `${typeTranslate} supprimé !`,
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function archiveSelection () {
      var contentObj
      switch (self.type) {
        case 'invoice':
          contentObj = ' facture(s)'
          break
        case 'quote':
          contentObj = ' devis'
          break
        case 'creditnote':
          contentObj = ' avoir(s)'
          break
      }
      var total = 0
      var toArchive = _.filter(self.selection.selectedData, function (elt) {
        if (!elt.isArchived) {
          total++
          return elt
        }
      })
      var content = "Vous êtes sur le point d'archiver " + total + contentObj + '.<br><br>Vous ne pourrez plus le(s) modifier ni le(s) dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Archiver', content).then(function () {
        self.loading = true
        doArchive(toArchive, function () {
          var label = total + contentObj + ' archivé(e)(s) !'
          SnackService.snack({
            text: label,
            delay: 5000
          })
          self.loading = false
          $state.reload()
        })
      })
    }

    function doArchive (toArchive, callback) {
      _.each(toArchive, function (elt) {
        elt.archive()
      })
      callback()
    }

    function restoreSelection () {
      var contentObj
      switch (self.type) {
        case 'invoice':
          contentObj = ' facture(s)'
          break
        case 'quote':
          contentObj = ' devis'
          break
        case 'creditnote':
          contentObj = ' avoir(s)'
          break
      }
      var total = 0
      var toRestore = _.filter(self.selection.selectedData, function (elt) {
        if (elt.isArchived) {
          total++
          return elt
        }
      })
      var content = 'Vous êtes sur le point de restaurer ' + total + contentObj + '.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        self.loading = true
        doRestore(toRestore, function () {
          var label = total + contentObj + ' restauré(e)(s) !'
          SnackService.snack({
            text: label,
            delay: 5000
          })
          self.loading = false
          $state.reload()
        })
      })
    }

    function doRestore (toRestore, callback) {
      _.each(toRestore, function (elt) {
        elt.restore()
      })
      callback()
    }

    function newTab (opt) {
      var url = ''
      for (var i = 0, len = self.selection.selectedData.length; i < len; i++) {
        if (opt.print) {
          url = $state.href((self.type + '.show.print'), { id: self.selection.selectedData[i]._id })
        } else {
          url = $state.href((self.type + '.show'), { id: self.selection.selectedData[i]._id })
        }
        $window.open(url, '_blank')
      }
    }

    function displayDeleteOrModification () {
      return self.type === 'product'
    }

    function displayPdf () {
      return self.type !== 'entity'
    }

    function displayChorus () {
      return (['creditnote', 'invoice'].includes(self.type))
    }

    function isChorusSelection () {
      const selection = self.selection.selectedData.filter(elt => elt?.chorusFields?.integratedOnChorus)
      return selection.length
    }

    function isNotProductNorEntity () {
      return self.type !== 'product' && self.type !== 'entity'
    }

    function displayArchive () {
      return isNotProductNorEntity() && !!_.find(self.selection.selectedData, function (elt) { return !elt.isArchived }) && self.allowArchiveAndRestore
    }

    function displayRestore () {
      return isNotProductNorEntity() && !!_.find(self.selection.selectedData, function (elt) { return elt.isArchived }) && self.allowArchiveAndRestore
    }

    function displayBulkValidate () {
      return isNotProductNorEntity() && _.every(self.selection.selectedData, ['status', 'draft'])
    }

    function displayBulkSent () {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('sent')
    }

    function displayBulkDunning () {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('dunning')
    }

    function displayBulkLitigation () {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('litigation')
    }

    function displayBulkPaid () {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('paid')
    }

    function isAllowedToTransition (status) {
      var allowed = true
      _.each(self.selection.selectedData, function (elt) {
        switch (elt.status) {
          case 'validated':
            if (!_.includes(['sent', 'paid', 'litigation', 'dunning'], status)) allowed = false
            break
          case 'sent':
          case 'partly_paid':
            if (!_.includes(['paid', 'litigation', 'dunning'], status)) allowed = false
            break
          case 'litigation':
            if (!_.includes(['paid', 'dunning'], status)) allowed = false
            break
          case 'dunning':
            if (!_.includes(['paid', 'litigation'], status)) allowed = false
            break
          default:
            allowed = false
        }
      })
      return allowed
    }

    function getBulkValidateUrl () {
      return urls.api + '/kilo/' + self.type + 's/bulkvalidate'
    }

    function getBulkStatusUrl () {
      return urls.api + '/kilo/' + self.type + 's/bulkstatus'
    }

    function getBulkPaymentUrl () {
      return urls.api + '/kilo/' + self.type + 's/bulkpayment'
    }

    function getBulkValidateBody () {
      return PreferencesService.getPrefsFor(self.type).then(function (prefs) {
        var body = {}
        body[self.type + 's'] = _.map(self.selection.selectedData, '_id')
        body.periodicity = prefs.periodicity
        body.resetDate = prefs.resetDate
        body.numberFormat = prefs.numberFormat
        return body
      })
    }

    function getBulkStatusBody (status) {
      var body = {}
      body[self.type + 's'] = _.map(self.selection.selectedData, '_id')
      body.status = status
      return body
    }

    function getSnackText () {
      var text = ''
      if (self.selection.selectedData.length > 1) {
        text += self.selection.selectedData.length
        switch (self.type) {
          case 'invoice':
            text += ' factures'
            break
          case 'quote':
            text += ' devis'
            break
          case 'creditnote':
            text += ' avoirs'
            break
          case 'order':
            text += ' chantiers'
            break
        }
      } else {
        switch (self.type) {
          case 'invoice':
            text += 'cette facture'
            break
          case 'quote':
            text += 'ce devis'
            break
          case 'creditnote':
            text += 'cet avoir'
            break
          case 'order':
            text += 'ce chantier'
            break
        }
      }
      return text
    }

    function getTextStatus (status) {
      switch (status) {
        case 'sent':
          return 'Envoyé'
        case 'dunning':
          return 'Relance'
        case 'litigation':
          return 'Litige'
        case 'paid':
          return 'Payé'
      }
    }

    function bulkValidate () {
      var url = getBulkValidateUrl()
      getBulkValidateBody().then(function (b) {
        var text = getSnackText()
        DisplayService.displayConfirm(
          'Valider',
          'Vous êtes sur le point de valider ' + text + ', êtes-vous sûr de vouloir continuer ?'
        ).then(function () {
          $http.put(url, b).then(
            function (d) {
              SnackService.snack({
                text: 'Traitement en cours...',
                delay: 5000
              })
            }
          )
        })
      })
    }

    function bulkPayment () {
      let url = getBulkPaymentUrl()
      let body = {}
      body.invoices = _.map(self.selection.selectedData, '_id')
      return $uibModal.open({
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: '/app/common/layouts/partials/modals/make-global-payment.html',
        controller: 'MakeGlobalPaymentController',
        resolve: {
          elements: function () {
            return self.selection.selectedData
          }
        }
      }).result.then((globalPayment) => {
        body.payment = globalPayment
        $http.put(url, body).then((d) => {
          SnackService.snack({
            text: 'Facture(s) passée(s) en payée(s) ...',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function bulkStatus (status) {
      var url = getBulkStatusUrl()
      var body = getBulkStatusBody(status)
      var text = getSnackText()
      var textStatus = getTextStatus(status)
      DisplayService.displayConfirm(
        'Changement de statut',
        'Vous êtes sur le point de passer ' + text + ' au statut "' + textStatus + '", êtes-vous sûr de vouloir continuer ?'
      ).then(function () {
        $http.put(url, body).then(
          function (d) {
            SnackService.snack({
              text: 'Traitement en cours...',
              delay: 5000
            })
          }
        )
      })
    }

    function bulkSynchroToChorus () {
      const selectedData = self.selection.selectedData.filter(elt => elt?.chorusFields?.integratedOnChorus)
      const type = self.selection.selectedData[0].getType()
      DisplayService.displayConfirm(
        'Envoi vers Chorus',
        `Vous êtes sur le point de synchroniser ${selectedData.length} éléments de la sélection avec Chorus êtes-vous sûr de vouloir continuer ?`
      ).then(function () {
        const payload = []
        selectedData.forEach((elt) => {
          payload.push({
            idFacture: elt.chorusFields.chorusInvoiceId,
            invoiceId: type === 'invoice' ? elt._id : null,
            creditNoteId: type === 'invoice' ? null : elt._id
          })
        })
        $rootScope.loadingPage = true
        ChorusService.rattacherHistoriqueBulk(payload).then(() => {
          $rootScope.loadingPage = false
          SnackService.snack({
            text: 'Statuts des factures synchronisé avec Chorus !',
            delay: 5000
          })
          return $state.reload()
        })
      })
    }

    // Factures sélectionnées éligibles à l'émission Pennylane : la facture
    // porte un numéro (même garde que le backend : 422 « sans numéro » —
    // plus de condition de statut ni de cancelByUser, décision 2026-07-10),
    // pas déjà envoyées, ni archivées/supprimées (mêmes exclusions que le
    // bouton de la fiche ; double filet : le backend re-vérifie).
    function getPennylaneEligible () {
      return self.selection.selectedData.filter((elt) =>
        !!elt.number && !elt.sentToPennylane && !elt.isArchived && !elt.isDeleted)
    }

    function displayPennylaneEmit () {
      return self.type === 'invoice' && self.pennylaneConnected && getPennylaneEligible().length > 0
    }

    function bulkEmitToPennylane () {
      const candidates = getPennylaneEligible()
      // Contrôle pré-émission des données client (checkInvoiceEmittable) : le
      // `client` des items de liste est peuplé par invoice-list.controller
      // (getList, select '__t type firstname lastname number label address' —
      // projection élargie exprès pour ce contrôle) → même contrôle que la
      // fiche, sans requête supplémentaire par facture. Sans client, le
      // backend rejetterait systématiquement (422) → ces factures rejoignent
      // les ignorées et ne partent pas ; champs incomplets = avertissement
      // agrégé seulement (requis uniquement si le customer n'existe pas
      // encore chez Pennylane — la webapp ne peut pas le savoir).
      const checks = candidates.map((elt) => PennylaneService.checkInvoiceEmittable(elt))
      const eligible = candidates.filter((elt, i) => !checks[i].blocking)
      const withWarnings = checks.filter((check) => !check.blocking && check.warnings.length).length
      if (!eligible.length) {
        // Plus aucune candidate avec client : on ne poste jamais un lot vide
        // (400 backend) — message immédiat, pas de confirm.
        SnackService.snack({
          text: 'Envoi impossible : aucune facture sélectionnée n\'a de client',
          delay: 10000
        })
        return
      }
      const ignored = self.selection.selectedData.length - eligible.length
      let content = eligible.length + ' facture(s) seront envoyée(s) sur Pennylane.'
      if (ignored > 0) {
        content += '<br><br>' + ignored + ' facture(s) sélectionnée(s) seront ignorée(s) (sans numéro, déjà envoyées ou sans client).'
      }
      if (withWarnings > 0) {
        content += '<br><br>' + withWarnings + ' facture(s) avec données client incomplètes — l\'envoi peut échouer si ces clients n\'existent pas encore chez Pennylane.'
      }
      DisplayService.displayConfirm('Envoyer sur Pennylane', content).then(function () {
        // Envoi réel — appelé après le gating PA ci-dessous. L'endpoint backend
        // est asynchrone (répond {accepted:N, items} immédiatement) → pas de
        // loadingPage à gérer. Pas de polling des Monitoring depuis la liste
        // (décision 2026-07-10 : un gros lot = des dizaines de GET /monitoring
        // toutes les 5 s) : l'issue par facture se consulte sur chaque fiche
        // (bandeau du dernier envoi, qui polle tant que c'est en cours).
        function doEmit () {
          return PennylaneService.emitInvoices(eligible.map((elt) => elt._id)).then(() => {
            SnackService.snack({
              text: 'Envoi sur Pennylane en cours',
              delay: 10000
            })
            $state.reload()
          }).catch(() => {
            SnackService.snack({
              text: 'Échec de l\'envoi sur Pennylane',
              delay: 10000
            })
          })
        }

        // Gating prod : bloque l'envoi si l'émission de factures n'est pas
        // autorisée côté Pennylane (inscription PA non activée). Vérification
        // au clic pour ne pas consommer le rate limit Pennylane (5 req/s).
        return PennylaneService.getConnectedCompany().then((company) => {
          if (!company) {
            SnackService.snack({ text: 'Échec de l\'envoi sur Pennylane', delay: 10000 })
            return
          }
          return PennylaneService.getPaRegistrations(company._id).then((res) => {
            if (!res.data.emissionAllowed) {
              SnackService.snack({ text: 'Émission de factures : Non autorisée', delay: 10000 })
              return
            }
            return doEmit()
          })
        }).catch(() => {
          SnackService.snack({ text: 'Échec de l\'envoi sur Pennylane', delay: 10000 })
        })
      })
    }

    function deleteSelection () {
      let ids = self.selection.selectedData.map(elt => elt._id)
      TemplateService.getAllPrefilledTemplates(ids).then((templates) => {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' +
          'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(() => {
            self.loading = true
            const url = urls.api + '/kilo/products/bulkProductDeletion'
            $http.put(url, { ids: ids, templates: templates }).then(() => {
              _.each(self.selection.selectedData, function (elt) {
                elt.remove()
              })
            })
            self.loading = false
            let label = self.selection.selectedData.length + ' produit(s) supprimé(s) !'
            SnackService.snack({
              text: label,
              delay: 5000
            })
            $state.reload()
          })
        } else {
          DisplayService.confirmDeletion().then(function () {
            self.loading = true
            self.selection.selectedData.forEach(elt => {
              elt.remove()
            })
            let label = self.selection.selectedData.length + ' produit(s) supprimé(s) !'
            SnackService.snack({
              text: label,
              delay: 5000
            })
            self.loading = false
            $state.reload()
          })
        }
      })
    }

    function modifySelection (products) {
      return $uibModal.open({
        controllerAs: '$ctrl',
        bindToController: true,
        size: 'md',
        resolve: {
          ids: [() => {
            return products.map(product => product._id)
          }]
        },
        templateUrl: '/app/common/layouts/partials/modals/modify.html',
        controller: 'ModifyController'
      }).result.then(function () {
        SnackService.snack({
          text: 'Produit(s) modifié(s) !',
          delay: 5000
        })
        $state.reload()
      })
    }

    function updatePrices (products) {
      const ids = products.map((product) => product._id)
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/product/show/controllers/modals/modify/modify-price-modal.template.html',
        controller: 'ModifyPriceModalController',
        controllerAs: 'ctrl'
      }).result.then((value) => {
        const url = urls.api + '/kilo/products/bulkProductModification'
        return $http.put(url, { type: 'price', ids: ids, value: value }).then(() => {
          SnackService.snack({
            text: 'Prix des produits modifiés !',
            delay: 3000
          })
          $state.reload()
        })
      })
    }

    function asPdf () {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return self.type }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/' + self.type + '/'
        if (template !== false) {
          url += template._id
        }
        if (self.type === 'invoice') {
          $http.post(url, { invoices: _.map(self.selection.selectedData, '_id') }).then(
            function (d) {
              SnackService.snack({
                text: 'Facture(s) exportée(s) en PDF !',
                delay: 5000
              })
            }
          )
        } else if (self.type === 'quote') {
          $http.post(url, { quotes: _.map(self.selection.selectedData, '_id') }).then(
            function (d) {
              SnackService.snack({
                text: 'Devis exporté(s) en PDF !',
                delay: 5000
              })
            }
          )
        } else if (self.type === 'creditnote') {
          $http.post(url, { creditNotes: _.map(self.selection.selectedData, '_id') }).then(
            function (d) {
              SnackService.snack({
                text: 'Avoir(s) exporté(s) en PDF !',
                delay: 5000
              })
            }
          )
        }
      })
    }

    function asCsv () {
      var url = urls.backend + '/services/csv/' + self.type + 's/'
      if (self.type === 'invoice') {
        $http.post(url, { invoices: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Facture(s) exportée(s) en CSV !',
              delay: 5000
            })
          }
        )
      } else if (self.type === 'quote') {
        $http.post(url, { quotes: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Devis exporté(s) en CSV !',
              delay: 5000
            })
          }
        )
      } else if (self.type === 'creditnote') {
        $http.post(url, { creditNotes: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Avoirs exporté(s) en CSV !',
              delay: 5000
            })
          }
        )
      }
    }

    function asSpreadsheet () {
      var url = urls.backend + '/services/spreadsheet/' + self.type + 's/'
      if (self.type === 'invoice') {
        $http.post(url, { invoices: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Facture(s) exportée(s) en feuille de calcul !',
              delay: 5000
            })
          }
        )
      } else if (self.type === 'quote') {
        $http.post(url, { quotes: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Devis exporté(s) en feuille de calcul !',
              delay: 5000
            })
          }
        )
      } else if (self.type === 'creditnote') {
        $http.post(url, { creditNotes: _.map(self.selection.selectedData, '_id') }).then(
          function (d) {
            SnackService.snack({
              text: 'Avoirs exporté(s) en feuille de calcul !',
              delay: 5000
            })
          }
        )
      }
    }
  }

  selectionSidebarDirective.$inject = []

  function selectionSidebarDirective () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/selection-sidebar/selection-sidebar.html',
      controller: SelectionSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        selection: '=',
        visible: '=',
        type: '@'
      }
    }
  }
})(window.angular, window.moment, window._)
